import createSagaMiddleware from 'redux-saga';

import {
  answersApi,
  configApi,
  employeesApi,
  filesApi,
  projectsApi,
  questionsApi,
  resultsApi,
  settingsApi,
  testsApi,
  themesApi,
  usersApi,
} from '@/services';

export const sagaMiddleware = createSagaMiddleware();

export const middlewares = [
  sagaMiddleware,
  ...[
    configApi,
    testsApi,
    resultsApi,
    questionsApi,
    answersApi,
    projectsApi,
    themesApi,
    filesApi,
    employeesApi,
    usersApi,
    settingsApi,
  ].map((api) => api.middleware),
];
